import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { CompanyPageDeleteCompanyContactModalComponent } from 'src/app/pages/mission-control-page/company-page/company-page-delete-company-contact-modal/company-page-delete-company-contact-modal.component';

// Downgraded (see service.module.ajs.js) so the still-AngularJS
// company-page.component.js root controller (native port not due until
// build step 10) can open this native modal in place of its old
// `this.$uibModal.open({component: 'deleteCompanyContactModal', ...})` call.
@Injectable({
  providedIn: 'root'
})
export class CompanyPageDeleteCompanyContactModalService {

  deleteCompanyContactModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(initialState: { userDetails: any; deleteContactUserInfo: any }, onResult: (callbackObject: any) => void): void {
    const config = new ModalConfig();
    config.class = 'four-dot-five-modal-medium';
    config.ignoreBackdropClick = true;
    config.initialState = initialState;
    this.deleteCompanyContactModal = this.bsModalService.show(CompanyPageDeleteCompanyContactModalComponent, config);
    this.deleteCompanyContactModal.content.onClose.subscribe((callbackObject: any) => {
      onResult(callbackObject);
    });
  }
}
